export const text = {
  product: "Add Product",
  submit: "Submit",
};
